import axiosInstance from "src/common/axiosInstance";

const base = (workspaceId) => `/workspaces/${workspaceId}/tags`;

/**
 * Workspace tags / labels. Tags are workspace-scoped; assigning them is done
 * per contact (conversations show their contact's tags).
 */
const tagService = {
  list(workspaceId, params = {}) {
    return axiosInstance.get(base(workspaceId), { params });
  },

  create(workspaceId, payload) {
    return axiosInstance.post(base(workspaceId), payload);
  },

  update(workspaceId, tagId, payload) {
    return axiosInstance.put(`${base(workspaceId)}/${tagId}`, payload);
  },

  remove(workspaceId, tagId) {
    return axiosInstance.delete(`${base(workspaceId)}/${tagId}`);
  },

  /** Replace a contact's tag set. */
  setContactTags(workspaceId, accountId, phoneNumberId, contactId, tagIds) {
    return axiosInstance.put(
      `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/phone-numbers/${phoneNumberId}/contacts/${contactId}/tags`,
      { tag_ids: tagIds },
    );
  },
};

export default tagService;
